import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.FundingTypeEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    fundingTypeEnumList: { items: data, total },
  } = await sdk.getListFundingTypeEnum(
    filterSortPage({
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { fundingTypeEnum: data } = await sdk.getOneFundingTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { fundingTypeEnumMany: data } = await sdk.getManyFundingTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const fundingTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
